<template>
  <f-form
      store="@freebe/codes"
      :id="id"
    >
      <template #default="{ item }">
        <div 
          v-if="item"
          class="is-grid"
        >
          <f-field 
            class="is-col-6"
            label="Nom"
          >
            <f-input 
              v-model="item.name"
              suffix-icon="user"
              :readonly="!canEdit"
            ></f-input>
          </f-field>

          <f-field 
            class="is-col-6"
            label="Code"
          >
            <f-input 
              v-model="item.code"
              suffix-icon="pricetag-alt"
              :readonly="!canEdit"
            ></f-input>
          </f-field>

          <f-field 
            class="is-col-6"
            label="Émetteur"
          >
            <f-select
              v-model="item.from"
              :options="fromOptions"
              :readonly="!canEdit"
              label="name"
              value="slug"
              long
            ></f-select>
          </f-field>

          <f-field 
            class="is-col-6"
            label="Rôles"
          >
            <f-select
              v-model="item.roles"
              :options="roleOptions"
              :readonly="!canEdit"
              label="name"
              value="slug"
              long
              multiple
            ></f-select>
          </f-field>

          <f-field 
            class="is-col-3"
            label="Montant"
          >
            <f-input 
              v-model="item.amount"
              :readonly="!canEdit"
            ></f-input>
          </f-field>

          <f-field 
            class="is-col-3"
            label="Type"
          >
            <f-select
              v-model="item.type"
              :options="typeOptions"
              :readonly="!canEdit"
              label="name"
              value="slug"
              small
            ></f-select>
          </f-field>

          <f-field 
            class="is-col-2 is-aligned"
            label="Expiration"
            inline
          >
            <f-toggle 
              v-model="hasValidity"
              @change="updateItem($event, item)"
              :readonly="!canEdit"
            ></f-toggle>
          </f-field>

          <f-field
            class="is-col-3 is-aligned"
            inline
          >
            <p v-if="!hasValidity">
              N'expire jamais
            </p>

            <f-datepicker 
              v-if="hasValidity"
              v-model="item.validity"
              :readonly="!canEdit"
            ></f-datepicker>
          </f-field>

          <div class="is-col-12">
            <hr>
          </div>

          <f-field 
            class="is-col-6"
            label="Partenaire"
          >
            <p v-if="!item.partner_id">
              Pas de partenaire sélectionné
            </p>

            <partner-card-list
              v-if="item.partner_id"
              :id="item.partner_id"
              @remove="item.partner_id = undefined"
              :removable="canEdit"
            ></partner-card-list>
          </f-field>

          <f-field 
            class="is-col-6"
            label="Contact"
          >
            <f-input 
              v-model="item.contact"
              suffix-icon="envelope"
            ></f-input>
          </f-field>
        </div>
        
        <select-partner
          v-if="!item.partner_id && canEdit"
          v-model:partner_id="item.partner_id"
          v-model:contact="item.contact"
        ></select-partner>
      </template>
    </f-form>
</template>

<script>
  import { computed, reactive, toRefs, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'
  import SelectPartner from '@components/partners/select-partner'
  import PartnerCardList from '@components/partners/view/partner-card-list'

  export default {
    props: {
      id: {
        type: String, 
        required: true,
      },
    },

    setup (props) {
      const { get } = useStore('@freebe/codes')
      const { checkPermissions } = useRoles()
      
      const canEdit = computed(() => 
        checkPermissions('freebe/pricing/codes:patch')
      )

      const code = computed(() => get(props.id))

      const hasValidity = ref(false)

      function updateItem (value, item) {
        item.validity = value ? new Date() : null 
      }

      const fromOptions = computed(() => {
        return [{
          name: 'Freebe',
          slug: 'freebe',
        }, {
          name: 'Partenaire',
          slug: 'partner',
        }, {
          name: 'Growth',
          slug: 'growth',
        }]
      })

      const typeOptions = computed(() => {
        return [{
          name: '%',
          slug: '%',
        }, {
          name: 'Mois',
          slug: 'months',
        }]
      })

      const roleOptions = computed(() => {
        return [{
          name: 'Utilisateurs',
          slug: 'users',
        }]
      })

      return {
        code, 
        canEdit,
        roleOptions,
        typeOptions,
        fromOptions,
        hasValidity,
        updateItem,
      }
    }, 

    components: {
      SelectPartner,
      PartnerCardList,
    }  
  }
</script>